<script setup lang="ts">
import { CoDialog } from '@deputy/copilot2';
import router from '@/router';

defineProps({
  showClose: Boolean,
});

defineEmits(['closed']);

function routeHome() {
  router.push({ name: 'home' });
}
</script>

<template>
  <CoDialog
    top="5vh"
    model-value
    clean-body
    :show-close="showClose"
    :clean-header="!showClose"
    dialog-size="medium"
    @closed="$emit('closed')"
    :before-close="routeHome"
    custom-class="pin-modal"
  >
    <div class="__dialog-container">
      <slot />
    </div>
  </CoDialog>
</template>

<style scoped>
.__div-container,
.__dialog-container {
  padding: 2rem;
}

.__dialog-container {
  display: flex;
  flex-direction: column;
  min-height: 225px;
  justify-content: center;
}
</style>

<style>
.pin-modal {
  border-radius: 32px !important;
  touch-action: manipulation;
}
</style>
